import { render } from "./MrZip.vue?vue&type=template&id=4e52a566&scoped=true"
import script from "./MrZip.vue?vue&type=script&lang=js"
export * from "./MrZip.vue?vue&type=script&lang=js"

import "./MrZip.vue?vue&type=style&index=0&id=4e52a566&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e52a566"

export default script